export const Types = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  INITIALIZE_USER_DATA: "INITIALIZE_USER_DATA",
  UPDATE_LOGO: "UPDATE_LOGO",
};
